import { useEffect, useState } from "react"
import { distinctUntilChanged, map } from "rxjs"
import type { UiState, Statuses } from "@callcenter/shared-types"
import { callcenterSocket } from "@callcenter/api"
import { UserService } from "@callcenter/services"

import { useAgentCommands } from "../use-agent-commands"

type StatusState = {
  status: Statuses
  uiState: UiState
  awayMessage: string
}

export const useAgentStatus = () => {
  const [state, setState] = useState<StatusState>({
    uiState: "" as UiState,
    status: "" as Statuses,
    awayMessage: ""
  })

  useEffect(() => {
    UserService.getCallcenterAndUserSettings().subscribe(({ user }) => {
      setState({ status: user.ui_state as Statuses, uiState: user.ui_state as UiState, awayMessage: "" })
    })
  }, [])

  useAgentCommands()

  useEffect(() => {
    const subscription = callcenterSocket.AgentChannel.agentInfo
      .pipe(
        map((agentData) => ({
          uiState: agentData.ui_state,
          status: agentData.status,
          awayMessage: agentData.away_message
        })),
        distinctUntilChanged()
      )
      .subscribe(setState)

    return () => subscription.unsubscribe()
  }, [])

  return state
}
